import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.min.css';
export const Simplebar = {
  init() {
    const els = document.querySelectorAll('[data-simplebar]');
    if (els.length) {
      els.forEach((el) => {
        new SimpleBar(el);
      });
    }
  },
};
